export default __webpack_public_path__ + "static/media/Step2GIF1.f3186d99.gif";